import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Import } from "iconsax-react";
import { Button, Dropdown, DropdownItem } from "@/shared/ui";

interface ReportsExportDropdownProps {
  onDownloadPL: () => void;
  onDownloadBalance: () => void;
  onDownloadEquityChanges: () => void;
  isLoading?: boolean;
}

export default function ReportsExportDropdown({
  onDownloadPL,
  onDownloadBalance,
  onDownloadEquityChanges,
  isLoading,
}: ReportsExportDropdownProps) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("FinancialReportPage");
  return (
    <Dropdown open={open} onClose={() => setOpen(false)} align="right">
      <Button
        variant="secondary"
        size="lg"
        className="w-8! h-8! p-0! flex rounded-lg! justify-center items-center content-base-secondary"
        onClick={() => setOpen(!open)}>
        <Import size={20} color="currentColor" />
      </Button>
      <DropdownItem
        onClick={() => {
          onDownloadPL();
          setOpen(false);
        }}
        disabled={isLoading}>
        {t("downloadPLReport")}
      </DropdownItem>
      <DropdownItem
        onClick={() => {
          onDownloadBalance();
          setOpen(false);
        }}
        disabled={isLoading}>
        {t("downloadBalanceSheet")}
      </DropdownItem>
      <DropdownItem
        onClick={() => {
          onDownloadEquityChanges();
          setOpen(false);
        }}
        disabled={isLoading}>
        {t("downloadEquityChanges")}
      </DropdownItem>
    </Dropdown>
  );
}

